<template>
	<section v-if="items.length" class="main-content">
		<div class="row row-header align-center">
			<h2>{{ header }}</h2>
			<h2 v-if="subtitle" class="subtitle">{{ subtitle }}</h2>
		</div>
		<div class="row faq-row">
			<div class="columns column12">
				<div v-for="(item, index) in items" :key="item.ID" c class="faq-item">
					<collapse
						:header="item.question"
						:content="item.answer"
						:is-open="activeIndex === index"
						@click="toggleCollapse(index)"
					/>
				</div>
			</div>
		</div>
	</section>
</template>

<script setup>
defineProps({
	header: { type: String, default: '' },
	subtitle: { type: String, default: '' },
	items: { type: Array, default: () => [] },
});

const activeIndex = ref(null);

const toggleCollapse = (index) => {
	activeIndex.value = activeIndex.value === index ? null : index;
};
</script>

<style lang="scss" scoped>
.main-content {
	margin: 0 auto 75px;
}

.faq-item {
	text-align: left;
	margin-top: -1px;

	&:first-child {
		margin-top: 0;
	}
}

.faq-row,
.row-header {
	max-width: 980px;
	padding: 0 125px;
}

.row-header {
	h2 {
		width: 100%;

		&.subtitle {
			font-family: var(--body-font-family);
			text-transform: uppercase;
		}
	}
}

.faq-row {
	.column12 {
		padding: 0;
	}
}
</style>
